import { Controller } from "@hotwired/stimulus"
import { dsConfirm } from "../../utils/ds_confirm";

export default class extends Controller {
  static targets = ["saveNotice"]
  static values = { confirm: String, error: String }

  async initializeDefaults() {
    if (await dsConfirm(this.confirmValue)) {
      fetch('/schools/accountings/settings/initialize_default_automatic_entries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Back on the automatic entries tab, already saved: the notice says so.
          const url = new URL(window.location.href)
          url.searchParams.set('initialized', '1')
          url.hash = 'automatic-entries'
          window.location.href = url.toString()
        } else {
          alert(data.message)
        }
      })
      .catch(error => {
        console.error(error)
        alert(this.errorValue)
      })
    }
  }

  connect() {
    const url = new URL(window.location.href)
    if (url.searchParams.get('initialized') === '1') {
      this.showSaveNotice()
      url.searchParams.delete('initialized')
      window.history.replaceState({}, '', url.toString())
    }
  }

  showSaveNotice() {
    if (this.hasSaveNoticeTarget) {
      this.saveNoticeTarget.classList.remove('hidden')
    }
  }

  async resetForm() {
    console.log("resetForm method called")
    try {
      if (await dsConfirm("Voulez-vous réinitialiser le formulaire? Cela rechargera la page pour revenir aux valeurs sauvegardées.")) {
        console.log("User confirmed, reloading...")
        // Recharger la page pour revenir aux valeurs sauvegardées
        window.location.reload()
      } else {
        console.log("User cancelled")
      }
    } catch (error) {
      console.error("Error in resetForm:", error)
    }
  }
}